module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!!_vm.arquivoScanGrv) ? _c('div', [_c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.deleteDocumento($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o m-r-xs"
  }), _vm._v(" Excluir Arquivo Scan\n    ")])]) : _c('div', [(_vm.loading) ? _c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin m-r-xs"
  })]) : _c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.openMultipleInputFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-sm"
  }), _vm._t("default", [_vm._v("Upload file")])], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "uploadScanGrv",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.uploadDocumento
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559a1f12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/BtnUploadArquivoGrv.vue
// module id = 1685
// module chunks = 17